<template>
  <main role="main" class="py-4">
    <b-container>
      <h4>{{ $t("newRegion") }}</h4>

      <!-- Form nhập liệu thông tin tạo mới khu vực kinh doanh -->
      <b-form class="mt-4 max-width-700" @submit.prevent="submitForm">
        <b-form-row>
          <!-- Trường mã khu vực (ẩn, tự sinh phía hệ thống) -->
          <b-form-group class="col-lg-12" style="display:none">
            <template v-slot:label>
              {{ $t("regionCode") }}<span class="text-danger">*</span>
            </template>
            <b-form-input type="text" minlength="1" maxlength="30" v-model="code" />
          </b-form-group>

          <!-- Tên khu vực kinh doanh (bắt buộc) -->
          <b-form-group class="col-lg-12">
            <template v-slot:label>
              {{ $t("regionName") }} <span class="text-danger">*</span>
            </template>
            <b-form-input
              type="text"
              :placeholder="$t('inputNameRegion')"
              required
              minlength="2"
              maxlength="50"
              v-model="name"
            />
          </b-form-group>

          <!-- Tiêu đề đếm số gói cước và nút mở modal thêm gói cước -->
          <b-form-group class="col-lg-12">
            <template v-slot:label>
              <b>{{ $t("selectedPackageCount", { count: selectedSubs.length }) }}</b>
            </template>
            <a class="btn btn-outline-primary btn-cus" @click="showModal" style="cursor:pointer">
              + {{ $t("add") }}
            </a>
          </b-form-group>

          <!-- Danh sách các gói cước đã chọn hiển thị xem trước -->
          <b-form-group class="col-lg-12">
            <div style="height: auto; max-height: 450px; overflow-y: auto;">
              <b-list-group class="contacts-list-group">
                <div v-if="!selectedSubs.length" class="py-3 text-center text-secondary">
                  {{ $t("noData") }}
                </div>
                <b-list-group-item v-for="sub in selectedSubs" :key="sub.id || sub.subscriptionPlanId">
                  <subscription-plan-item :plan="sub" />
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-form-group>
        </b-form-row>

        <!-- Nút Tạo khu vực -->
        <div class="text-right" style="margin: 5px;">
          <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("create") }}</b-button>
        </div>
      </b-form>
    </b-container>

    <!-- Component modal chọn gói cước dạng Transfer list dùng chung -->
    <subscription-plan-selection-modal
      ref="planSelectionModal"
      v-model="selectedSubs"
    />
  </main>
</template>

<script lang="ts">
import { Component, Ref } from "vue-property-decorator";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import BaseComponent from "@/components/BaseComponent";
import SubscriptionPlanItem from "@/views/location/components/SubscriptionPlanItem.vue";
import SubscriptionPlanSelectionModal from "@/views/location/components/SubscriptionPlanSelectionModal.vue";

/**
 * Màn hình Tạo mới khu vực kinh doanh (/location/new).
 * Luồng nghiệp vụ:
 * 1. Nhập tên khu vực.
 * 2. Chọn các gói cước gán vào khu vực qua modal SubscriptionPlanSelectionModal.
 * 3. Gửi payload { name, listIdSubcriptionPlans } lên server.
 * 4. Thông báo thành công và chuyển hướng về trang danh sách khu vực.
 */
@Component({
  components: {
    SubscriptionPlanItem,
    SubscriptionPlanSelectionModal
  }
})
export default class NewRegion extends BaseComponent {
  /** Tham chiếu đến modal chọn gói cước */
  @Ref("planSelectionModal") planSelectionModal!: SubscriptionPlanSelectionModal;

  /** Tên khu vực kinh doanh */
  name = "";
  /** Mã khu vực */
  code = "";
  /** Trạng thái đang gửi form tạo mới */
  isSubmitting = false;
  /** Danh sách các gói cước đã được chọn cho khu vực này */
  selectedSubs: any[] = [];

  /** Mở modal chọn gói cước */
  showModal() {
    this.planSelectionModal.showModal();
  }

  /**
   * Submit form tạo mới khu vực:
   * - Trích xuất mảng ID gói cước từ danh sách đã chọn.
   * - Gọi API tạo mới khu vực.
   */
  async submitForm() {
    try {
      this.isSubmitting = true;

      // Trích xuất danh sách ID các gói cước được gán
      const selectedPlanIds = (this.selectedSubs || [])
        .map(item => (item.id != null ? item.id : item.subscriptionPlanId))
        .filter(Boolean);

      const data = {
        name: this.name,
        listIdSubcriptionPlans: selectedPlanIds
      };

      await subscriptionPlanService.saveRegion(data);
      this.goBackToList();
    } catch (e) {
      this.toastError(e);
    } finally {
      this.isSubmitting = false;
    }
  }

  /** Chuyển hướng về trang danh sách khu vực kinh doanh và hiển thị toast thông báo thành công */
  goBackToList() {
    this.$router.push("/location");
    this.toastSuccessDelay(this.$t("createRegionSuccessful").toString());
  }
}
</script>

<style lang="scss" scoped>
.btn-cus {
  float: right;
  margin-top: -30px;
}
</style>
